import { newsletterRoutes } from "@circle-react/lib/routes/newsletter";
import { createFileRoute, redirect } from "@tanstack/react-router";

import { fetchNewsletterPost } from "@/react/components/SettingsApp/Newsletters/helpers";

export const Route = createFileRoute(
  "/_protected/_settingsLayout/settings/newsletter/posts/$id/",
)({
  beforeLoad: async ({ params, context }) => {
    const post = await fetchNewsletterPost(context.queryClient, params.id);

    redirect({
      href: (post?.status === "draft"
        ? newsletterRoutes.postContent
        : newsletterRoutes.postOverview)({ path: { id: params.id } }),
      replace: true,
      throw: true,
    });
  },
});
